import angular from 'angular';

var module = angular.module('app.me', []);

export default module;